// Developer: Ankit Gupta
import { Modal, Typography, Table, Tag } from 'antd';
import { KeyOutlined } from '@ant-design/icons';
import { useT } from '@/i18n';

const { Text } = Typography;

interface ShortcutModalProps {
  open: boolean;
  onClose: () => void;
}

interface ShortcutItem {
  key: string;
  shortcut: string;
  description: string;
  scope: string;
}

const SHORTCUTS: ShortcutItem[] = [
  { key: '1', shortcut: 'Ctrl + K  /  Cmd + K', description: 'Open Global Command Palette & Navigation Search', scope: 'Global' },
  { key: '2', shortcut: '?  or  Ctrl + /', description: 'Open Keyboard Shortcuts Guide', scope: 'Global' },
  { key: '3', shortcut: 'Ctrl + Enter', description: 'Run Query in Rhino SQL Workbench', scope: 'Rhino IDE' },
  { key: '4', shortcut: 'Ctrl + Space', description: 'Trigger SQL Editor Autocomplete', scope: 'Rhino IDE' },
  { key: '5', shortcut: 'Alt + Shift + F', description: 'Format active SQL Query', scope: 'Rhino IDE' },
  { key: '6', shortcut: 'Esc', description: 'Close Modals / Exit Fullscreen Editor', scope: 'Global' },
];

export function ShortcutModal({ open, onClose }: ShortcutModalProps) {
  const { t } = useT('shell');
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <KeyOutlined style={{ color: 'var(--dp-violet-2)' }} />
          <span>{t('shortcuts.title')}</span>
        </div>
      }
      width={580}
    >
      <Table
        dataSource={SHORTCUTS}
        pagination={false}
        size="small"
        columns={[
          {
            title: t('shortcuts.colShortcut'),
            dataIndex: 'shortcut',
            key: 'shortcut',
            width: 200,
            render: (sc: string) => <Text code className="dp-ltr-value" style={{ fontWeight: 600, color: 'var(--dp-violet)' }}>{sc}</Text>,
          },
          {
            title: t('shortcuts.colAction'),
            dataIndex: 'description',
            key: 'description',
            render: (desc: string, row: ShortcutItem) => <Text style={{ fontSize: 13 }}>{t(`shortcuts.action.${row.key}`, { defaultValue: desc })}</Text>,
          },
          {
            title: t('shortcuts.colScope'),
            dataIndex: 'scope',
            key: 'scope',
            width: 110,
            render: (scope: string) => <Tag color={scope === 'Global' ? 'blue' : 'purple'}>{t(`shortcuts.scope.${scope === 'Global' ? 'global' : 'rhino'}`, { defaultValue: scope })}</Tag>,
          },
        ]}
      />
    </Modal>
  );
}

export default ShortcutModal;
